// Kept alongside other domain messages; non-Russian locales fall back to English.
export const sponsorMessages = {
  ru: {
    eyebrow: 'Давай познакомимся с командой',
    title: 'Кто пригласил тебя в Gonka Game?',
    description: 'Логин пригласителя не сохранился при регистрации. Введи его, чтобы открыть остальные разделы.',
    label: 'Логин пригласителя',
    placeholder: 'Введи логин',
    submit: 'Сохранить пригласителя',
    hint: 'Не знаешь логин? Уточни его у того, кто тебя пригласил. Пока можно открыть профиль или выйти из аккаунта.',
    profile: 'Открыть профиль',
    logout: 'Выйти из аккаунта',
    banner: 'Добавь пригласителя, чтобы открыть все разделы Gonka Game.',
    add: 'Указать пригласителя',
    notFound: 'Пригласитель с таким логином не найден. Проверь логин и попробуй ещё раз.',
    invalid: 'Нельзя выбрать себя или участника своей команды. Укажи логин того, кто тебя пригласил.',
    unconfirmed: 'Пока не удалось подтвердить пригласителя. Попробуй ещё раз — остальные разделы откроются после подтверждения.',
  },
  en: {
    eyebrow: 'Let’s meet your team',
    title: 'Who invited you to Gonka Game?',
    description: 'Your inviter’s login was not saved during registration. Enter it to unlock the other sections.',
    label: 'Inviter’s login',
    placeholder: 'Enter login',
    submit: 'Save inviter',
    hint: 'Don’t know the login? Ask the person who invited you. You can still open your profile or sign out.',
    profile: 'Open profile',
    logout: 'Sign out',
    banner: 'Add your inviter to unlock all Gonka Game sections.',
    add: 'Add inviter',
    notFound: 'No inviter found with this login. Check the login and try again.',
    invalid: 'You cannot choose yourself or someone in your own team. Enter the login of the person who invited you.',
    unconfirmed: 'We could not confirm your inviter yet. Try again — the other sections will unlock once confirmed.',
  },
}
